import { request, firebaseRequest } from '@/utils/request'

// request
export const reqServiceList = () => request.get('customerize/list')

export const reqSearchCustomer = (phone) =>
  request.get(`customer/v2?phone=${phone}`)

// firebaseRequest
export const reqOnNote = (teamCode) =>
  firebaseRequest.get(`note?code=${teamCode}`)



// WEBPACK FOOTER //
// ./src/api/hail/index.js